export default __webpack_public_path__ + "static/media/case-hardening-icon-dark.73d1fcde.svg";